$('document').ready(() => {
    const complectSlider = new Swiper('.complect-slider', {
        slidesPerView: 1,
        allowTouchMove: false,
        autoHeight: true,
        navigation: {
            nextEl: '.complect-slider__nav--next',
            prevEl: '.complect-slider__nav--prev',
            cliclable: true,
        },
    });

    const complectItemsSlider = new Swiper('.complect-slider__items', {
        enabled: false,
        breakpoints: {
            768: {
                enabled: true,
                slidesPerView: 2,
                spaceBetween: 16,
                scrollbar: {
                    el: '.complect-slider__items-scrollbar',
                    hide: false,
                    draggable: true,
                },
            },
            1024: {
                spaceBetween: 16,
                enabled: true,
                slidesPerView: 3,
                scrollbar: {
                    el: '.complect-slider__items-scrollbar',
                    hide: false,
                    draggable: true,
                },
            }
        }
    })
    const complectItemsSliderFit = new Swiper('.complect-slider__items--fit', {
        enabled: false,
        breakpoints: {
            768: {
                enabled: true,
                slidesPerView: 2,
                spaceBetween: 16,
                scrollbar: {
                    el: '.complect-slider__items-scrollbar',
                    hide: false,
                    draggable: true,
                },
            },

            1024: {
                enabled: true,
                slidesPerView: 2,
                spaceBetween: 16,
                scrollbar: {
                    el: '.complect-slider__items-scrollbar',
                    hide: false,
                    draggable: true,
                },
            }
        }
    })
});
